import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page from "@insite/mobius/Page";
import Typography from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import CustomApplicationState from "@thos/Store/CustomApplicationState";
import React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        location: getLocation(state),
    };
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & HasHistory;

const UserVerificationPage = ({ id, location }: Props) => {
    const [userVerified, setUserVerified] = React.useState(false);
    const [isVerifying, setIsVerifying] = React.useState(true);
    const [error, setUserVerificationError] = React.useState(false);
    const queryStrings = parseQueryString<any>(location.search);
    React.useEffect(() => {
        setIsVerifying(true);
        const fetchData = async () => {
            try {
                const response = await fetch(`/api/v1/userverification/verifyuser?userId=${queryStrings.userId}`);

                if (!response.ok) {
                    // Handle 500 errors or any other non-successful responses
                    setUserVerificationError(true);
                    return;
                }

                setUserVerified(true);
                setIsVerifying(false);

            } catch (error) {
                setUserVerificationError(true);
            }
        };
        fetchData();
    }, []);


    return (
        <Page>
            {userVerified && !isVerifying && !error && (<StyledWrapper>
                <Typography>
                    {translate("User has been succesfully verified")}
                </Typography>
            </StyledWrapper>)}
            {!userVerified && isVerifying && !error && (<StyledWrapper>
                <Typography>
                    {translate("Verifying user...")}
                </Typography>
            </StyledWrapper>)}
            {!userVerified && error && (<StyledWrapper>
                <Typography>
                    {translate("There was an error processing verification. Please contact customer service.")}
                </Typography>
            </StyledWrapper>)}
            <Modals />
        </Page>
    );
};

const pageModule: PageModule = {
    component: withHistory(connect(mapStateToProps)(UserVerificationPage)),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [],
        pageType: "System",
    },
};

export default pageModule;
